import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import PodcastList from './views/PodcastList.vue'
import PodcastDetail from './views/PodcastDetail.vue'
import EpisodeDetail from './views/EpisodeDetail.vue'
import NewsList from './views/NewsList.vue'
import CalendarList from './views/CalendarList.vue'

const routes = [
	{ path: '/', name: 'Home', component: HomeView },
	{
		path: '/podcasts',
		children: [
			{ 
				path: '',
				name: 'PodcastsList', 
				component: PodcastList
			},
			{ 
				path: 'senaste',
				name: 'PodcastListLatest',
				component: PodcastList,
				props: () => ({ 
					sort: 'latest'
				})
			},
			{ 
				path: 'favorites',
				name: 'PodcastsListFavourites',
				component: PodcastList,
				props: () => ({ 
					sort: 'favourites'
				})
			},
			{ 
				path: 'fortsatt',
				name: 'PodcastsListContinues',
				component: PodcastList,
				props: () => ({ 
					sort: 'continues'
				})
			},
			{ 
				path: ':id',
				name: 'PodcastDetail', 
				component: PodcastDetail,
				props: true
			},
			{ 
				path: ':podcastId/episode/:episodeId',
				name: 'EpisodeDetail', 
				component: EpisodeDetail 
			}
		]
	},
	{
		path: '/nyheter',
		children: [
			{ 
				path: '',
				name: 'NewsList', 
				component: NewsList 
			}
		]
	},
	{
		path: '/calendar',
		children: [
			{ 
				path: '',
				name: 'CalendarList', 
				component: CalendarList 
			}
		]
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { top: 0, behavior: 'smooth' }
		}
	}
})

export default router
